import { useState } from 'react';
import axios from 'axios';

export const useFileUpload = (baseUrl) => {
  const [loading, setLoading] = useState(false);
  const [response, setResponse] = useState(null);
  const [error, setError] = useState(null);
  const [progress, setProgress] = useState(0);

  const uploadFile = async (formData) => {
    setLoading(true);
    setError(null);
    setResponse(null);
    setProgress(0);
    let res;

    try {
      res = await axios.post(baseUrl, formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
        onUploadProgress: (progressEvent) => {
          const percentCompleted = Math.round((progressEvent.loaded * 100) / progressEvent.total);
          setProgress(percentCompleted);
        },
      });

      setResponse(res.data);
    } catch (err) {
      setError(err);
      throw err;
    } finally {
      setLoading(false);
    }

    return res?.data;
  };
  return { uploadFile, response, error, loading, progress };
};
